//#region Libraries
import { useNavigate } from "react-router";
//#endregion
//#region Styles
import { FooterFormManualLoading } from "components/styles";
//#endregion
//#region Components
import Preloader from "components/Preloader/Preloader";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";
//#endregion
//#region Services
import { eventsSessionStorage } from "services/storage/events";
//#endregion
//#region Utils
import { useNavigatingAway } from "utils/hooks/usePrompt";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import useEventFormActions from "../../utils/hooks/useEventFormActions";
import useFinalizeEvent from "../../utils/hooks/useFinalizeEvent";
import DialogErrorScheduleWithCrossings from "../DialogErrorScheduleWithCrossings/DialogErrorScheduleWithCrossings";
import useSchedulesWithCrossings from "../../utils/hooks/useSchedulesWithCrossings";
//#endregion

const Footer = ({
	currentStep,
	createEvent, stepsQuantity,
	nextStep, toStep,
	form, errors,
	changeErrorsStep,
	setMustCorrect,
	setMustCorrectMessage,
	canShowDialogLeavingPage,
	showToastMessageSaveEventAsDraft,
	setCanShowDialogLeavingPage,
	changeErrorText, eventResumeData,
	isCompletedForm, teacherZoomAccountDetail
}) => {
	//#region Extra
	const navigate = useNavigate();
	const loadingRequest = useLoadingRequest();
	//#region Manejo de salida de vista
	const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
		useNavigatingAway(canShowDialogLeavingPage);
	//#region Dialog Windows
	const dialogShowErrorVacantCapacityForGreaterThanTheLimit =
		useShowDialogAlert();
	const dialogShowCreatedEvent = useShowDialogAlert((toggle, value) => {
		toggle();
		if (value === false) toEventList();
	});
	const dialogShowUpdatedEvent = useShowDialogAlert((toggle, value) => {
		toggle();
		if (value === false) toEventList();
	});
	const dialogShowCancelEvent = useShowDialogAlert((toggle, value) => {
		toggle();
		if (value === false) toEventList();
	});
	//#endregion
	const finalizeEvent = useFinalizeEvent({
		loadingRequest,
		form, nextStep,
		toggleShowDialogCreatedEvent: dialogShowCreatedEvent.toggle,
	});
	const schedulesWithCrossingsHandler = useSchedulesWithCrossings({
		toStep
	});
	const { 
		saveAndContinue, 
		saveEventAsDraft, 
		updateEventStep 
	} = useEventFormActions({
		loadingRequest,
		form,
		nextStep,
		toStep,
		teacherZoomAccountDetail,
		errors,
		changeErrorsStep,
		setMustCorrect,
		setMustCorrectMessage,
		setShowDialogUpdatedEvent: dialogShowUpdatedEvent.set,
		showToastMessageSaveEventAsDraft,
		changeErrorText,
		eventResumeData,
		isCompletedForm,
		setCanShowDialogLeavingPage,
		dialogShowErrorVacantCapacityForGreaterThanTheLimit,
		currentStep,
		showDialogSchedulesWithCrossings: schedulesWithCrossingsHandler.showDialog
	});
	//#endregion
	//#endregion
	//#region Functions
	const goToEventList = () => {
		eventsSessionStorage.openPastEventCertificatesOnly.remove();
		navigate(ABSOLUTE_PATHS.EVENT_LIST);
	};
	const toEventList = () => {
		setTimeout(() => {
			goToEventList();
			confirmNavigation();
		}, 380);
	};
	const cancelEvent = async () => {
		setCanShowDialogLeavingPage(false);
		dialogShowCancelEvent.toggle();
		goToEventList();
		confirmNavigation();
	};
	const getMessageErrorVacantCapacity = () => {
		const { zoomTypeId } = form.step2.part2;
		if (zoomTypeId === 1)
			return "Recuerda que elegiste la opción para 300 o menos invitados";
		return `Recuerda que tu cuenta es para máximo ${teacherZoomAccountDetail?.guests} invitados`;
	};
	//#endregion
	const isDraft = eventsSessionStorage.isDraftEvent.get();
	return (
		<>
			<FooterFormManualLoading>
				<div>
					<CustomButton
						text="Cancelar"
						variant="sixtinary"
						onClick={() => navigate(ABSOLUTE_PATHS.EVENT_LIST)}
					/>
					{createEvent && currentStep < stepsQuantity && (
						<CustomButton
							variant="quintinary"
							text="Guardar Borrador"
							onClick={saveEventAsDraft}
						/>
					)}
				</div>
				{currentStep >= stepsQuantity ? (
					isDraft || createEvent ? (
						<CustomButton
							text="Finalizar"
							onClick={finalizeEvent}
						/>
					) : (
						<CustomButton
							text="Cerrar"
							onClick={goToEventList}
						/>
					)
				) : isDraft || createEvent ? (
					<CustomButton
						text="Guardar y continuar"
						onClick={saveAndContinue}
					/>
				) : (
					<CustomButton
						text="Actualizar"
						onClick={updateEventStep}
					/>
				)}
			</FooterFormManualLoading>
			<Preloader {...loadingRequest.value} />
			<DialogAlertAction
				show={dialogShowCancelEvent.value}
				toggleShow={dialogShowCancelEvent.toggle}
				title={`¿Deseas cancelar ${
					createEvent ? "la creación" : "el editado"
				} de tu evento?`}
				content="Recuerda que esta información no se guardará y tendrás que empezar de nuevo."
			>
				<CustomButton
					variant="quintinary"
					width="130px"
					text="Sí, salir"
					onClick={cancelEvent}
				/>
				<CustomButton
					variant="quaternary"
					width="130px"
					text="No, continuar"
					onClick={() => dialogShowCancelEvent.set(false)}
				/>
			</DialogAlertAction>
			<DialogAlertAction
				show={showDialogLeavingPage}
				toggleShow={cancelNavigation}
				title="¿Deseas salir sin guardar tu evento?"
				content="Recuerda que al salir, la información que has escrito recientemente, no se guardará"
			>
				<CustomButton
					variant="quintinary"
					text="Sí, salir"
					width="130px"
					onClick={confirmNavigation}
				/>
				<CustomButton
					variant="quaternary"
					text="No, continuar"
					width="130px"
					onClick={cancelNavigation}
				/>
			</DialogAlertAction>
			<DialogAlertAction
				variant="secondary"
				minWidth="500px"
				widthContent="100%"
				show={dialogShowErrorVacantCapacityForGreaterThanTheLimit.value}
				toggleShow={
					dialogShowErrorVacantCapacityForGreaterThanTheLimit.toggle
				}
				title="Capacidad de vacantes incorrecto"
				content={getMessageErrorVacantCapacity()}
			>
				<CustomButton
					text="Cerrar"
					onClick={() =>
						dialogShowErrorVacantCapacityForGreaterThanTheLimit.set(
							false
						)
					}
				/>
			</DialogAlertAction>
			<DialogAlertSuccessNotify
				show={dialogShowCreatedEvent.value}
				toggleShow={dialogShowCreatedEvent.toggle}
				title="Hemos creado tu evento"
				description="Lo podrás visualizar en el listado de eventos"
				buttons={
					<CustomButton
						variant="quaternary"
						text="Ir al listado de eventos"
						onClick={() => {
							dialogShowCreatedEvent.set(false);
							toEventList();
						}}
					/>
				}
			/>
			<DialogAlertSuccessNotify
				show={dialogShowUpdatedEvent.value}
				toggleShow={dialogShowUpdatedEvent.toggle}
				title="Hemos actualizado tu evento"
				description="Lo podrás visualizar en el listado de eventos"
				buttons={
					<CustomButton
						variant="quaternary"
						text="Ir al listado de eventos"
						onClick={() => {
							dialogShowUpdatedEvent.set(false);
							toEventList();
						}}
					/>
				}
			/>
			<DialogErrorScheduleWithCrossings {...schedulesWithCrossingsHandler.forComponent}/>
		</>
	);
};

export default Footer;
